import React, { Component } from 'react'
import { connect } from 'react-redux'
import Colors from 'material-ui/styles/colors'

let select = (state) => state


export class StarsRating extends Component {
	constructor(props) {
		super(props);
			this.state = {
				value: (props.value < 0)? 0 : (props.value > 5)? 5 : props.value,
				ratingView: ["star", "star", "star", "star", "star"],
				starStyle: {color: (props.color)?props.color: "#3cd2ae",
					cursor: (props.clickable)?"pointer":"default",
					fontSize: props.size,
					userSelect: "none",
					WebkitUserSelect: "none",
					MozUserSelect: "-moz-none",
					KhtmlUserSelect: "none",
					MsUserSelect: "none"
				}
			}
		}

		componentDidMount(){
			if (this.props.value){
				var newView = this.state.ratingView
				for(var i = 5; i>this.state.value; i--){
					newView[i-1] = "star_border"
				}
				this.setState({ratingView: newView})
			}
		}

		handleChange = (value) => {
			let temp = (value == this.state.value)?value-1:value
			let newView = ["star_border", "star_border", "star_border", "star_border", "star_border"]
			for(var i = 0; i<temp; i++){
				newView[i] = "star"
			}
			this.setState({ratingView: newView, value: temp})
			if(this.props.onChange) this.props.onChange(temp)
		}

		render() {
			return (
				<div style={this.props.style} className={(this.props.className)? this.props.className : ""}>

					<i className="material-icons"
						style={{
							...this.state.starStyle
						  , color: (this.state.ratingView[0] == "star_border")? "#d0d0d0" : (this.props.scheme != "blue")? "#3cd2ae" : "#009be1"
						}}
						onTouchTap = {() => {if(this.props.clickable){this.handleChange(1)}}}
					>
					star</i>

					<i className="material-icons"
						style={{
							...this.state.starStyle
						  , color: (this.state.ratingView[1] == "star_border")? "#d0d0d0" : (this.props.scheme != "blue")? "#3cd2ae" : "#009be1"
						}}
						onTouchTap = {() => {if(this.props.clickable){this.handleChange(2)}}}
					>
					star</i>

					<i className="material-icons"
						style={{
							...this.state.starStyle
						  , color: (this.state.ratingView[2] == "star_border")? "#d0d0d0" : (this.props.scheme != "blue")? "#3cd2ae" : "#009be1"
						}}
						onTouchTap = {() => {if(this.props.clickable){this.handleChange(3)}}}
					>
					star</i>

					<i className="material-icons"
						style={{
							...this.state.starStyle
						  , color: (this.state.ratingView[3] == "star_border")? "#d0d0d0" : (this.props.scheme != "blue")? "#3cd2ae" : "#009be1"
						}}
						onTouchTap = {() => {if(this.props.clickable){this.handleChange(4)}}}
					>
					star</i>

					<i className="material-icons"
						style={{
							...this.state.starStyle
						  , color: (this.state.ratingView[4] == "star_border")? "#d0d0d0" : (this.props.scheme != "blue")? "#3cd2ae" : "#009be1"
						}}
						onTouchTap = {() => {if(this.props.clickable){this.handleChange(5)}}}
					>
					star</i>

				</div>
			)
		}
}

export default connect(select)(StarsRating)



// WEBPACK FOOTER //
// ./src/components/StarsRating.js